import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import { bindActionCreators } from 'redux';
import LanguageField from 'profile/components/language_field';
import partial from 'lodash/partial';

export function mapStateToProps(state, { input: { name }, formName }) {
  if (!state.profile.languages.data) {
    return null;
  }

  const selector = formValueSelector(formName);
  const languageCode = selector(state, name);

  return {
    language: languageCode,
    languageOptions: state.profile.languages.data.list,
  };
}

export function mapDispatchToProps(dispatch, { name, formName }) {
  return bindActionCreators({
    onChange: partial(change, formName, name),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageField);



// WEBPACK FOOTER //
// ./profile/containers/language_field.js